import { Link } from 'react-router-dom';
import type { NewsArticle } from '@/types/media';
import { formatDate } from '@/utils/media';

interface NewsCardProps {
  article: NewsArticle;
  variant?: 'row' | 'card';
}

export default function NewsCard({ article, variant = 'row' }: NewsCardProps) {
  if (variant === 'card') {
    return (
      <Link
        to={`/news/detail/${article.id}`}
        className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 cursor-pointer"
      >
        <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
          <img
            src={article.cover}
            alt={article.title}
            title={`${article.title} - 91爱爱资讯`}
            className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute left-2 top-2 rounded-md bg-secondary-500/90 px-2 py-0.5 text-[11px] font-medium text-background-50">
            {article.category}
          </span>
        </div>
        <div className="flex flex-1 flex-col gap-2 p-4">
          <h3 className="line-clamp-2 font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
            {article.title}
          </h3>
          <p className="line-clamp-2 text-sm leading-relaxed text-foreground-600">{article.summary}</p>
          <div className="mt-auto flex items-center gap-3 pt-2 text-xs text-foreground-400">
            <span className="flex items-center gap-1">
              <i className="ri-time-line" />
              {formatDate(article.publishedAt)}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-newspaper-line" />
              {article.source}
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/detail/${article.id}`}
      className="group flex gap-4 rounded-lg border border-transparent p-2 transition-colors hover:border-background-200 hover:bg-background-100/60 cursor-pointer"
    >
      <div className="relative h-20 w-32 shrink-0 overflow-hidden rounded-md bg-background-200">
        <img
          src={article.cover}
          alt={article.title}
          title={`${article.title} - 91爱爱资讯`}
          className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-1.5">
        <h3 className="line-clamp-2 font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
          {article.title}
        </h3>
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-500">{article.summary}</p>
        <div className="mt-auto flex items-center gap-3 text-[11px] text-foreground-400">
          <span className="rounded bg-accent-100 px-1.5 py-0.5 text-accent-800">{article.category}</span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line" />
            {formatDate(article.publishedAt)}
          </span>
        </div>
      </div>
    </Link>
  );
}